// Redirect 2 Packs of Products to their associated Single Product
if (window.location.href.indexOf('/products/copy-of-bio-clear-detoxification-capsules') > -1) {
    window.location.href = '/products/bio-clear-detox-capsules';
}
else if (window.location.href.indexOf('/products/bio-defense-immunity-capsules-2pack') > -1){
    window.location.href = '/products/bio-defense';
}
else if (window.location.href.indexOf('/products/5-in-1-bio-heal-probiotic-capsules-2-pack') > -1){
    window.location.href = '/products/bio-heal-probiotic-capsules';
}
else if (window.location.href.indexOf('/products/5-in-1-bio-heal-probiotic-powder-2-pack') > -1){
    window.location.href = '/products/bio-heal-probiotic-powder';
}
else if (window.location.href.indexOf('/products/copy-of-bio-heal-pro-probiotic-capsules') > -1){
    window.location.href = '/products/bio-heal-pro-capsules';
}
else if (window.location.href.indexOf('/products/bio-heal-pro-probiotic-powder-unflavored-2pack') > -1){
    window.location.href = '/products/bio-heal-pro-probiotic-powder-unflavored';
}
else if (window.location.href.indexOf('/products/2-pack-multi-advanced-multi-vitamin-capsules-1') > -1){
    window.location.href = '/products/multi-vitamin-capsules';
}
else if (window.location.href.indexOf('/2-pack-multi-advanced-multi-vitamin-tropical-flavored-powder') > -1){
    window.location.href = '/products/multi-vitamin-powder-tropical';
}
else if (window.location.href.indexOf('/products/2-pack-multi-advanced-multi-vitamin-capsules') > -1){
    window.location.href = '/products/multi-vitamin-powder-unflavored';
}
else if (window.location.href.indexOf('/products/sound-asleep-capsules-2pack') > -1){
    window.location.href = '/products/sound-asleep-capsules';
}

// If Subscribe and Save is Active, Require User to Select Frequency
window.addEventListener('DOMContentLoaded', function(){
  if ( document.querySelector('body').classList.contains('template-product') ) {
    console.log('template-product');

    // Modal
    const modal = document.getElementById('error-frequency');
    const btn = document.getElementById('error-button');
    const span = document.getElementsByClassName('close')[0];

    // When the user clicks the button, open the modal
    btn.onclick = function() {
      modal.style.display = 'flex';
      document.querySelector('body').classList.add('no-scroll');
    }

    // When the user clicks on <span> (x), close the modal
    span.onclick = function() {
      modal.style.display = 'none';
      document.querySelector('body').classList.remove('no-scroll');
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target === modal) {
        modal.style.display = 'none';
        document.querySelector('body').classList.remove('no-scroll');
      }
    }

    function checkSubSave() {
      const radio = document.querySelector('.rc_widget__option__input--subsave:checked');
      const select = document.querySelector('.rc-selling-plans__dropdown');
      if (radio && select.value === 'required') {
        return true;
      } else {
        return false;
      }
    }

    document.querySelector('button.js-go-cart-add-to-cart').addEventListener('click', function(event){
      // If Subscription is selected, ensure a frequency is picked
      console.log('add to cart click');
      if (checkSubSave()) {
        event.preventDefault();
        modal.style.display = 'flex';
        document.querySelector('body').classList.add('no-scroll');
      }

    })
  }
});


// Hamburger Animation
$( ".hamburger" ).click(function() {
  $( this ).toggleClass( "is-active" );
});

// Open External links in new window
var links = document.links; 
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

// Mobile Menu
var navTrigger = document.getElementsByClassName('hamburger')[0];

if (navTrigger !== undefined) {
  navTrigger.addEventListener('click', toggleNavigation);
}

function toggleNavigation(event) {
  event.preventDefault();

  var body = document.getElementsByTagName('body')[0]
  body.classList.toggle('open');

  //$('#menu').css('top', $('.header').height() + 40 + 'px');
  $('#menu').css('top', '0px');
}

// Smooth Scroll Animation
//var scroll = new SmoothScroll('a[href*="#"]');



//PLYER VIDEOS
$( '.videoplayer' ).each( function() {
  const player = new Plyr(this, {
    poster: '//aspirenutrition.com/cdn/shop/t/130/assets/thumbnail.png?v=143753308142648959251761868982',
    hideControls: true,
  });
});

// SEARCH 
$('.user-icons').on("click", function(e) {
	$('#search-pop').hide();
});

$("body").on("click", '.js-show-search, .search-close', function(e) {
	$('#search-pop').css('top', $('.header').height() + 40 + 'px')
	if($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
		$(".index .header").removeClass('header_bar');
		$('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
	} else {
		$(".index .header").addClass('header_bar');
		$('.index .header .logo img').attr('src', $('.logo img').data('src'));
	}

	$('#search-pop').fadeToggle('fast').find('input').focus();
	e.stopPropagation();
	e.preventDefault();
});


// QTY Adjust
/* JS Quantity Incrementers */
jQuery(function(){
	var j = jQuery; 
	var addInput = '.js-qty-wrap'; 

	j(addInput).each(function() { 
	var inputEl = j(this).closest(addInput).find('input');
	var n = inputEl.val(); 
	var plusEl = j(this).closest(addInput).find('.plus');
	var minEl = j(this).closest(addInput).find('.min');
	//On plus click add 1 to n
	plusEl.on('click', function(){
		inputEl.val(++n);
	});
	//On min click 
	minEl.on('click', function(){
	//If n is bigger or equal to 1 subtract 1 from n 
		if ( ( inputEl.val() ) >= 1) {
		inputEl.val(--n);
		} 
	});
	});
});


// Above header promo carousel
$(document).ready(function() {
  $('.component-promo-bar .promo-bar-slider').slick({
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true,
    prevArrow: '<button type="button" class="slick-prev">&#8249;</button>',
    nextArrow: '<button type="button" class="slick-next">&#8250;</button>',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
        }
      }
    ]
  });
});


$('.js-blog-carousel').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
	responsive: [     
    {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 3,
   		slidesToScroll: 3,
      }
    },
    {
      breakpoint: 768,
      settings: {
       	slidesToShow: 1,
   		  slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
      centerMode: true,
		  centerPadding: '60px',
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
        arrows:false,
      }
    }
  ]                              
});
 
// PDP CAROUSEL WITH THUMBS
$('.js-slider-primary').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  infinite:false,
  asNavFor: '.js-slider-thumbs',
  prevArrow: "<a href='#' class='previous-arrow'><i class='aspire-chevron-left'></i></a>",
  nextArrow: "<a href='#' class='next-arrow'><i class='aspire-chevron-right'></i></a>",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode:true,
          arrows:false,
      }
    }
  ]
});

$('.js-slider-thumbs').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.js-slider-primary',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite:false,
  variableWidth: false,
  arrows: true,
	prevArrow: "<a href='#' class='previous-arrow'><i class='aspire-chevron aspire-chevron-left'></i></a>",
  nextArrow: "<a href='#' class='next-arrow'><i class='aspire-chevron aspire-chevron-right'></i></a>",
});


// AS SEEN ON HOME CAROUSEL - INIT SLICK SLIDER:  
$( '.js-as-seen-on' ).each( function() {
  $( this ).slick( {
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 300,
    infinite:true,
    dots:false,
    centerMode:false,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows:false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }   
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
          arrows: true
        }   
      }   
    ]
  } );
} );


// SUCCESS STORIES SLIDERS

$('.js-success-stories-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  draggable:false,
  fade: true,
  infinite:true,
  asNavFor: '.js-slider-nav'
});

$('.js-slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows:true,
  infinite:true,
  asNavFor: '.js-success-stories-slider',
  focusOnSelect: true, // <--- this is necessary on the thumbnail slider! - JG
  prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><i class='aspire-chevron-left'></i></button>",
  nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button'><i class='aspire-chevron-right'></i></button>",
});



// GETTING STARTED PAGE TAB COLLECTION SLIDER - INIT SLICK SLIDER:  
$( '.js-tab-collection' ).each( function() {
  $( this ).slick( {
    infinite:false,
    // 1024+ this is in a half-page col, so default to 1 up
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><i class='aspire-chevron-left text-white'></i></button>",
    nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button'><i class='aspire-chevron-right text-white'></i></button>",
      responsive: [
      {
        breakpoint: 1023, // max width
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 767, // max width
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576, // max width
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  } );
});
  

// RECOMMENDED PRODUCTS CAROUSEL - INIT SLICK SLIDER:  
$(window).on('load', function() {
  $('.js-recommendation-carousel').slick({
    infinite:false,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><i class='aspire-chevron-left'></i></button>",
    nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button'><i class='aspire-chevron-right'></i></button>",
      responsive: [
      {
        breakpoint: 767, // max width
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows:false,

        }
      },
      {
        breakpoint: 576, // max width
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          variableWidth:true,
          centerMode:true,
        }
      }
    ]
  });
});
  


// RECOMMENDED PRODUCTS CAROUSEL - INIT SLICK SLIDER:  
$(window).on('load', function() {
  $('.js-product-recommendations').slick({
    infinite:false,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows:true,
    prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button'><i class='aspire-chevron-left'></i></button>",
    nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button'><i class='aspire-chevron-right'></i></button>",
      responsive: [
      {
        breakpoint: 767, // max width
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false
        }
      },
      {
        breakpoint: 576, // max width
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false,
          variableWidth:true,
          centerMode:true,
        }
      }
    ]
  });
});


// HOME PAGE SPOTLIGHT SECTION 
$('.js-spotlight-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots:true,
  fade: true,
  infinite:false
});


// Footer Nav
function resizeHandler() {
  // console.log("window resized");
  if ($(window).width() < 1024) {
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else{
     $('.footer-nav ul').show();
     $('.footer-nav-header').removeClass("expanded");
  }
}
resizeHandler();
$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function(e) {
  if ($(window).width() < 1024) {
    e.preventDefault();
    var $clicked = $(this);
  
    $('.footer-nav-header').each(function(){
      if ($(this).hasClass('expanded') && $(this)[0] != $clicked[0] ) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
      }
    });
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
    return false;
  }

  //  if ($(window).width() < 1024) {
    //  $(this).next().slideToggle(200);
      //$(this).toggleClass("expanded");
  //  }
});








class CoreBundleBtn extends HTMLElement {
  constructor() {
    super();
    this.data =  JSON.parse(this.querySelector('[type="application/json"]').innerHTML);
    this.btn = this.querySelector('a.button');
    this.cartCount = document.querySelector('.go-cart-counter');
  }

  connectedCallback() {
    this.btn.addEventListener('click', (e)=>{
      e.preventDefault();
      this.submitBtn();
    })
  }

  submitBtn(){
    const body = JSON.stringify({
        items: this.data.map(item => {
          return {
            quantity: 1,
            id: item.id
          }
        })
    });

    fetch(`/cart/add`, { ...{
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/json` }
    }, body })
    .then((response) => response.json())
    .then((parsedState) => {
      window.upcartRefreshCart();
      this.cartCount.innerHTML = parsedState.items.length;
    })
    .catch((e) => {
        console.error(e);
        alert('operation failed');
    })
  }
}

customElements.define('core-bundle-btn', CoreBundleBtn);